/* eslint-disable max-len */
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import { Link } from 'react-router-dom';
import { Table } from '../../components';
import CalendarCustom from '../../components/Calendar/CalendarCustom';
// eslint-disable-next-line max-len
import { COURSE_BY_STUDENT_STATUS, DATE_YMD, DATE_YMD_ISO, SETTING_TOOL_CERTIFICATE_STATUS_MAPPER, SETTING_TOOL_CERTIFICATE_TYPE, SETTING_TOOL_CERTIFICATE_TYPE_MAPPER, STUDENT_STATUS, SYSTEM_PATH, THEME_TYPE } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import SendMessageScreen from './SendMessageScreen';
import { debounce } from 'lodash'
import classNames from 'classnames';
import { ToolCertificateComponent } from '../Profile/ToolCertificateScreen';
import ResignationScreen from './ResignationScreen';
import { handleDownloadFile } from '../../core/utils/file';
import DepartmentTransferModal from './DepartmentTransferModal';


const StudentGroupScreen = observer(props => {
    const [courses, setCourses] = useState([]);
    const [showListCourse, setShowListCourse] = useState(false);
    const [courseName, setCourseName] = useState();
    const [courseId, setCourseId] = useState();

    const [keepDataSearch, setKeepDataSearch] = useState({});
    const [formatGroupOptions, setFormatGroupOptions] = useState([]);

    const fetchRef = useRef(0);

    // store
    const {
        groupAdminStore: {
            studentsOfCompany, pagingStudentOfCompany, disabledStudentIdx, studentsOfCompanyActive,
            getStudentsOfCompany, setAttrObservable, clean,
            getTicketByGroup, ticketByGroup,
            searchAttendancesOfCompany, getTicketPlansForGA,
            exportStudentCSV, exportTestResultCsv, selectedGroupIds, selectedDepartmentIds, gaFilterMode
        },
        modalStore: { openAlert, show, hide, openErrorModal },
        apiStore: { showLoading, hideLoading },
        courseStore: { getCoursesByName },
        userStore: {
            userInfoHeader
        }
    } = useStore();

    const userInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    const isDepartmentFilter = useMemo(() => {
        if (userInfoHeader?.departmentId) {
            return true;
        }
        return !!userInfoHeader?.enableDepartmentHierarchy && gaFilterMode === 'department';
    }, [userInfoHeader?.departmentId, userInfoHeader?.enableDepartmentHierarchy, gaFilterMode]);

    const getCurrentFilterPayload = () => {
        if (isDepartmentFilter) {
            return selectedDepartmentIds?.length > 0 ? { departmentIds: selectedDepartmentIds } : {};
        }
        return selectedGroupIds?.length > 0 ? { groupIds: selectedGroupIds } : {};
    };
    
    

    // state
    const { register, handleSubmit, formState: { isSubmitting, errors }, getValues, setValue, trigger, watch, control } = useForm({
        defaultValues: {
            childrenGroupId: '',
            attendanceCodeId: '',
            ticketPlanId: ''
        }
    });
    // #17899 — 研修指定受講プラン dropdown options, refetched whenever the selected 受講コード changes.
    const [ticketPlanOptions, setTicketPlanOptions] = useState([]);
    // AsyncSelect needs the {value,label} pair to display, not just the raw id react-hook-form holds.
    const [selectedAttendanceCodeOption, setSelectedAttendanceCodeOption] = useState(null);
    const attendanceCodeIdWatch = watch('attendanceCodeId');
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [isSelectedAllCustom, setIsSelectedAllCustom] = useState(false);
    const [toolCertificateTypeSearch, setToolCertificateTypeSearch] = useState([]);
    const [toolCertificateStatusSearch, setToolCertificateStatusSearch] = useState([]);
    const [toggleClearSelectedBtn, setToggleClearSelectedBtn] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    const selectedRowIds = useMemo(() => {
        const obj = {};
        selectedStudent.forEach(item => {
            obj[item.id] = true;
        });
        return obj;
    }, [selectedStudent])

    const studentSelectedInDirectGroup = useMemo(() => {
        return selectedStudent.every(item => item.groupId === userInfoHeader.groupId)
    }, [selectedStudent])

    const canShowDepartmentTransfer = useMemo(() => {
        return !!userInfoHeader?.enableDepartmentHierarchy && !!userInfoHeader?.canTransferDepartment;
    }, [userInfoHeader?.enableDepartmentHierarchy, userInfoHeader?.canTransferDepartment]);

    // lifecycle
    useEffect(() => {
        if (userInfoHeader?.id) {
            getStudentsOfCompany({
                ...getCurrentFilterPayload(),
                parentGroup: userInfoHeader?.groups?.length > 1
            });
            getTicketByGroup({
                parentGroup: userInfoHeader?.groups?.length > 1
            });
        }

        window.addEventListener('click', onFocus);

        return () => {
            window.removeEventListener('click', onFocus);
        }
    }, [userInfoHeader, selectedGroupIds, selectedDepartmentIds, isDepartmentFilter]);

    useEffect(() => {
        if (userInfoHeader?.groups?.length > 0) {
            setFormatGroupOptions([{
                value: '',
                label: '全ての法人'
            },
            ...userInfoHeader.groups.map(group => ({
                value: group.id,
                label: group.name
            }))
            ])
        }
    }, [userInfoHeader])



    const onFocus = () => {
        setShowListCourse(false);
    }


    const onFetchData = async (tableData, unsetPaging) => {
        !unsetPaging && setAttrObservable('pagingStudentOfCompany', tableData, true, false);
        const searchParams = {
            ...getValues(),
            courseId,
            ...tableData
        };
        const {
            isCompleteRate,
            isTotalCourseApply,
            ...payload
        } = searchParams;
        if (!searchParams?.ticketId || searchParams?.ticketId == 0) {
            delete payload?.ticketId;
        }
        if (!isCompleteRate) {
            delete payload?.completeRate;
        }
        if (!isTotalCourseApply) {
            delete payload?.totalCourseApply;
        }

        if (!isCompleteRate && !isTotalCourseApply) {
            delete payload?.isBiggerCompleteRate;
        }
        if (toolCertificateTypeSearch.length > 0) {
            payload['toolCertificateType'] = toolCertificateTypeSearch
        }
        if (toolCertificateStatusSearch.length > 0) {
            payload['toolCertificateStatus'] = toolCertificateStatusSearch
        }

        // setGroupIdSearch(payload.childrenGroupId);
        Object.assign(payload, getCurrentFilterPayload());

        // #17935 — 受講期間 (this screen's own date-range picker, auto-generates a 1-year-minus-
        // 1-day end date — see onChangeDateRange) and 申込み期間 (a separate, freely-picked date
        // range field — see the `<label>申込み期間</label>` CalendarCustom below) used to be merged
        // into the same fromDateStartCoursePeriod/toDateStartCoursePeriod pair via `||` fallback,
        // so the backend couldn't tell which field a search actually came from. Now sent as two
        // independent pairs — see UserService#paginateStudentInGAGroup for why that matters.
        let fromDateStartCoursePeriod = payload?.startCoursePeriod?.[0]?.startDate && !isNaN(payload?.startCoursePeriod?.[0]?.startDate)
            ? moment(payload.startCoursePeriod[0].startDate).format(DATE_YMD_ISO) : null;

        let toDateStartCoursePeriod = payload?.startCoursePeriod?.[0]?.endDate && !isNaN(payload?.startCoursePeriod?.[0]?.endDate)
            ? moment(payload.startCoursePeriod[0].endDate).format(DATE_YMD_ISO) : null;


        let fromDateApplicationPeriod = payload?.coursePeriod_1?.[0]?.startDate && !isNaN(payload?.coursePeriod_1?.[0]?.startDate)
            ? moment(payload.coursePeriod_1[0].startDate).format(DATE_YMD_ISO) : null;

        let toDateApplicationPeriod = payload?.coursePeriod_1?.[0]?.endDate && !isNaN(payload?.coursePeriod_1?.[0]?.endDate)
            ? moment(payload.coursePeriod_1[0].endDate).format(DATE_YMD_ISO) : null;


        delete payload?.startCoursePeriod;
        delete payload?.coursePeriod_1;

        const payloadWithCoursePeriods = {
            ...payload,
            fromDateStartCoursePeriod,
            toDateStartCoursePeriod,
            fromDateApplicationPeriod,
            toDateApplicationPeriod
        };

        // #17935 — was 2 calls to setKeepDataSearch back to back, the second (plain `payload`,
        // no date fields) always winning and silently dropping 受講期間/申込み期間 from
        // `keepDataSearch`. That state is what re-fetches replay (e.g. onFetchData(keepDataSearch)
        // after closing the 単位管理ツール/退職確認 modals below) — before this fix, closing either
        // modal silently reset the list to unfiltered-by-date. NOTE: onExportCSV also spreads
        // keepDataSearch into its request body, but the export-csv backend endpoint only reads
        // `userIds`/`searchByDate` from it — it does not filter by course period at all, with or
        // without this fix (separate, structurally unrelated limitation — not addressed here).
        setKeepDataSearch(payloadWithCoursePeriods);
        getStudentsOfCompany({
            ...payloadWithCoursePeriods,
            parentGroup: userInfoHeader?.groups?.length > 1
        });
    }

    const onSearchData = (data) => {
        setAttrObservable('pagingStudentOfCompany', { ...pagingStudentOfCompany, page: 1 }, true, false);
        onFetchData(data, true);
    }

    const onSelectedAllChange = (value) => {
        setSelectedStudent(oldUsers => {
            let data = oldUsers;
            toJS(studentsOfCompanyActive).forEach(userRow => {
                const index = data.findIndex(e => e.id === userRow.id);
                if (value) {
                    if (index < 0) data = [...data, userRow];
                } else {
                    if (index > -1) data = [...data.slice(0, index), ...data.slice(index + 1)];
                }
            })

            return data;
        })
        setIsSelectedAllCustom(value);
    }

    const onSelectedChange = (selectedRows, rows) => {
        if (!selectedRows) {
            setSelectedStudent([]);
            setIsSelectedAllCustom(false);
            return;
        }

        const selectedIds = Object.keys(selectedRows);
        if (selectedIds?.length > 0) {
            setSelectedStudent(oldUsers => {
                let data = oldUsers;
                toJS(studentsOfCompanyActive).forEach(userRow => {
                    const index = data.findIndex(e => e.id === userRow.id);
                    if (selectedIds.includes(String(userRow.id))) {
                        if (index < 0) {
                            data = [...data, userRow];
                        }
                    } else {
                        if (index > -1) {
                            data = [...data.slice(0, index), ...data.slice(index + 1)];
                        }
                    }
                })

                const dataIds = data.map(e => e.id);
                if (toJS(studentsOfCompanyActive)?.length > 0) {
                    setIsSelectedAllCustom(toJS(studentsOfCompanyActive).every(e => dataIds.includes(e.id)));
                } else {
                    setIsSelectedAllCustom(false);
                }

                return data;
            })
        } else {
            setSelectedStudent([]);
            setIsSelectedAllCustom(false);
        }
    }

    const onShowSendMessage = () => {
        if (selectedStudent?.length > 0) {
            window.$('#sendMessageScreenModal').modal('show');
        } else {
            openAlert('メッセージを送信する受講者を選択してください。');
        }
    }

    const onShowResignation = () => {
        
        window.$('#resignationScreenModal').modal('show');
    }

    const onShowDepartmentTransfer = () => {
        window.$('#departmentTransferModal').modal('show');
    }

    const onCloseDepartmentTransfer = () => {
        window.$('#departmentTransferModal').modal('hide');
    }

    const handleAfterDownloadDepartmentTransferTemplate = (msg) => {
        if (msg) {
            openErrorModal('エラー', msg);
        }
        hideLoading();
    };

    const onDownloadDepartmentTransferTemplate = () => {
        showLoading();
        handleDownloadFile({
            url: 'department-transfer/template-csv',
            method: 'get',
            cb: handleAfterDownloadDepartmentTransferTemplate
        });
    };

    const onExportCSV = () => {
        if (selectedStudent?.length > 0) {
            exportStudentCSV({
                userIds: selectedStudent.map(e => e.id),
                ...(keepDataSearch || {}),
                parentGroup: String(userInfoHeader?.groups?.length > 1)
            });
        } else {
            exportStudentCSV({
                ...(keepDataSearch || {}),
                parentGroup: String(userInfoHeader?.groups?.length > 1)
            });
        }
    }

    const onExportTestResultCsv = () => {
        if (selectedStudent?.length > 0) {
            exportTestResultCsv({
                userIds: selectedStudent.map(e => e.id),
                ...getCurrentFilterPayload(),
                courseId: courseId,
                parentGroup: String(userInfoHeader?.groups?.length > 1)
            });
        } else {
            exportTestResultCsv({
                userIds: [],
                ...getCurrentFilterPayload(),
                courseId: courseId,
                parentGroup: String(userInfoHeader?.groups?.length > 1)
            });
        }
    }

    const clearSelectedStudent = () => {
        setToggleClearSelectedBtn(!toggleClearSelectedBtn);
        setSelectedStudent([]);
    }

    const onChangeCheckbox = (field, value, otherField) => {
        setValue('completeRate', '');
        setValue('totalCourseApply', '');
        if (value && !getValues('isBiggerCompleteRate')) {
            setValue('isBiggerCompleteRate', '0');
        }
        setValue(field, value, { shouldValidate: true });
        if (value && getValues(otherField) === true) {
            setValue(otherField, false, { shouldValidate: true });
        }
    }

    // search courses
    const debounceFetcherCourses = useMemo(() => {
        const loadOptions = (courseName) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            getCoursesByName({ name: courseName, status: 1, themeType: THEME_TYPE.NORMAL }).then(res => {
                if (fetchId && fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }

                setCourses(res);
                setShowListCourse(res?.length > 0);
            })
        }

        return debounce(loadOptions, 800);
    }, [getCoursesByName]);

    const handleChangeCourse = (event) => {
        const courseName = event.target.value;
        debounceFetcherCourses(courseName);
        setCourseName(courseName);
        if (courseName === '') {
            setCourseId(undefined);
        }
    }

    const handleSelectCourse = (course) => {
        setCourseName(course?.name);
        setCourseId(course?.id);
        setShowListCourse(false);
    }

    // #17899 — 受講コード combobox: server-side search, scoped to the same group/department the rest
    // of this screen is filtered by (own group + children, mirrors getCurrentFilterPayload above).
    const loadAttendanceCodeOptions = (inputValue) => {
        return searchAttendancesOfCompany({
            search: inputValue || undefined,
            ...getCurrentFilterPayload(),
            parentGroup: userInfoHeader?.groups?.length > 1
        }).then(list => (list || []).map(item => ({ value: item.id, label: item.attendanceCode })));
    };

    // #17899 — 研修指定受講プラン options depend on the selected 受講コード; re-fetch on every change and
    // drop any plan selection that no longer applies to the newly selected code (or to "全て").
    useEffect(() => {
        if (!userInfoHeader?.id) return;
        getTicketPlansForGA({
            attendanceCodeId: attendanceCodeIdWatch || undefined,
            ...getCurrentFilterPayload(),
            parentGroup: userInfoHeader?.groups?.length > 1
        }).then(list => {
            setTicketPlanOptions(list || []);
            setValue('ticketPlanId', '');
        });
    }, [attendanceCodeIdWatch, userInfoHeader?.id]);

    function calculateDateAfterYear(date, years = 1, formatDate = DATE_YMD) {
        if (!date) return '';
        return moment(date).add(years, 'years').subtract(1, 'days').format(formatDate);
    }

    const calculateRemainingDays = (startCurrentPeriod, periods) => {
        if (!startCurrentPeriod || periods.length === 0) {
            return;
        }

        let currentPeriodIndex = -1;
        let remainingDays = -1;

        for (let i = 0; i < periods.length; i++) {
            if (startCurrentPeriod === periods[i].startDate) {
                currentPeriodIndex = i + 1;
                const endPeriodDate = moment(periods[i].startDate, 'YYYY-MM-DD').add(1, 'year').subtract(1, 'day');
                remainingDays = endPeriodDate.startOf('day').diff(moment().startOf('day'), 'days') + 1;
                break;
            }
        }
        return {
            remainingDays,
            currentPeriodIndex
        }
    };
    const onCheckToolCertificateTypeSearch = (value) => {
        if (toolCertificateTypeSearch.includes(value)) {
            setToolCertificateTypeSearch((prev) => prev.filter(item => item !== value))
        } else {
            setToolCertificateTypeSearch((prev) => [...prev, value])
        }
    }

    const onCheckToolCertificateStatusSearch = (value) => {
        if (toolCertificateStatusSearch.includes(value)) {
            setToolCertificateStatusSearch((prev) => prev.filter(item => item !== value))
        } else {
            setToolCertificateStatusSearch((prev) => [...prev, value])
        }
    }
    const onChangeDateRange = (ranges, field) => {
        const selection = ranges?.selection;


        if (!selection?.startDate || !selection?.endDate) {
            setValue(field, ranges?.selection ? [ranges.selection] : undefined);
            trigger(field);
            return;
        }

        let { startDate, endDate } = selection;
        const start = moment(startDate);

        //EndDate is not selected, or EndDate conflicts with StartDate (the starting point was just clicked).
        if (!endDate || start.isSame(endDate, 'day')) {
            // #17935 — was `.add(1, 'years')` alone (off by one day vs the comment's own stated
            // intent). A student's actual 受講期間 always ends start + 1 year - 1 day (same
            // formula as the result column below and DateUtils.caculateCoursePeriodEnd on the
            // backend) — keep this default consistent with that so the search's exact-match
            // logic (see UserService#paginateStudentInGAGroup) can actually match a real period.
            endDate = start.clone().add(1, 'years').subtract(1, 'day').toDate();
        }
        // If EndDate is selected and the distance is more than one year, limit it to one year from the start date.
        else {
            // #17935 follow-up — this manual-pick clamp is a separate, pre-existing cap unrelated
            // to the auto-gen default fixed above; #17935 only asked to fix the auto-gen formula.
            // Tightening this clamp to `-1 day` too (as an earlier revision of this fix did, for
            // "consistency") silently blocked GA from ever picking start + 1 year as EndDate — any
            // click on that date got clamped back to the same start + 1 year - 1 day value with no
            // feedback. Restored to the original `+1 year` (no -1 day) cap so manual EndDate
            // selection keeps its prior range of freedom; only the default suggestion changed.
            const oneYearFromStart = start.clone().add(1, 'years');

            if (moment(endDate).isAfter(oneYearFromStart)) {
                // If EndDate is selected and the distance is more than one year, limit it to one year from the start date.
                endDate = oneYearFromStart.toDate();
            }
        }


        setValue(field, [{
            ...selection,
            endDate
        }]);

        trigger(field);

    };




   

    const handleShowToolCertificateModal = (userId, syncEnable) => {
        show({
            id: 'modal-setting-tool-certificate-for-ga',
            isOpen: true,
            header: '単位管理ツール',
            onCancel: () => {
                hide();
                onFetchData(keepDataSearch);
            },
            children: (
                <div
                    className='wrapper main-student-list main-Attended-couse main-purchasse-history tool-certificate-screen pd-10'
                    style={{ overflow: 'auto', maxHeight: 'calc(100vh - 2 * 60px)', minHeight: '500px' }}>
                    <div className='top-student-list'>
                        <ToolCertificateComponent isPopup userId={userId} syncEnable={syncEnable} />
                    </div>
                </div>
            ),
            type: 'medium max-width-900'
        })
    }

    const handleShowResignationModal = (userInfo) => {
        
        show({
            id: 'modal-setting-resignation-for-ga',
            isOpen: true,
            header: '退職確認',
            onCancel: () => {
                hide();
                onFetchData(keepDataSearch);
            },
            children: (
                <div
                    className='wrapper main-student-list main-Attended-couse main-purchasse-history tool-certificate-screen pd-10'
                    style={{ minHeight: '300px' }}>
                    <div className='top-student-list'>
                        <ResignationScreen isPopup userInfo={userInfo} hide={hide} onFetchData={onFetchData} />
                    </div>
                </div>
            ),
            type: 'medium max-width-900'
        })
    }

    // student columns
    const studentColumns = useMemo(() => {
        const defaultColumns = [
            // {
            //     Header: 'No.',
            //     headerClassName: 'sticky-column sticky-column-left-1 width-80',
            //     className: 'sticky-dropdown sticky-column sticky-column-left-1 width-80',
            //     disableSortBy: true,
            //     Cell: ({ initialState, row }) => {
            //         return (
            //             <div style={{ textAlign: 'center' }}>
            //                 {
            //                     initialState?.initialTableState?.pageSize *
            //                     initialState?.initialTableState?.pageIndex +
            //                     row.index +
            //                     1
            //                 }
            //             </div>
            //         )
            //     },

            //     width: '80'
            // },
            {
                Header: '受講者名',
                headerClassName: 'sticky-column sticky-column-left-1',
                className: 'sticky-dropdown sticky-column sticky-column-left-1',
                accessor: 'firstName',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.firstName} {original?.lastName}
                        </div>
                    );
                },
                width: '150'
            },
            {
                Header: 'メールアドレス',
                accessor: 'email',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.email}
                        </div>
                    );
                },
                width: '220'
            },
            {
                Header: 'テスト正答率平均値（一回目）',
                accessor: 'averageScore',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div style={{
                            fontWeight: 500,
                            color: '#FFA600'
                        }}>
                            {original?.averageScore != null ? `${+original.averageScore.toFixed(2)}%` : '-'}
                        </div>
                    );
                }
            },
            ...(userInfoHeader?.enableDepartmentHierarchy ? [{
                Header: '部署名',
                accessor: 'departmentName',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    const raw = original?.departmentName;
                    const dept = raw != null && String(raw).trim() !== '' ? String(raw).trim() : '';
                    return (
                        <div className='name-ticket'>
                            {dept || '--'}
                        </div>
                    );
                },
                width: '160'
            }] : []),
            {
                Header: '受講期間',
                accessor: 'coursePeriod',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {
                                original?.coursePeriod ?
                                    // eslint-disable-next-line max-len
                                    `${original.coursePeriod.replace(/-/g, '/')} ~ ${moment(original.coursePeriod).add(1, 'years').subtract(1, 'd').format(DATE_YMD)}` : ''
                            }
                        </div>
                    );
                },
                width: '150'
            },
            {
                Header: '受講コース',
                accessor: 'ticketName',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.ticketName}
                        </div>
                    );
                },
                width: '180'
            },
            {
                // #17899 — default: 消化率 of the student's current plan; when GA is filtering by a
                // specific 研修指定受講プラン, ticketPlanName is set and shown below the rate (spec line 26).
                Header: '消化率',
                accessor: 'completionRate',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div className='text-center'>
                            {original?.completionRate != null ? `${original.completionRate}%` : '--'}
                            {original?.ticketPlanName && (
                                <div style={{ color: '#AAAAAA', fontSize: '12px' }}>{original.ticketPlanName}</div>
                            )}
                        </div>
                    );
                },
                width: '130'
            },
            {
                Header: '申請単位数',
                accessor: 'countCourseApplied',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.countCourseApplied}
                        </div>
                    );
                },
                width: '130'
            },
            {
                Header: '単位管理ツール',

                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    const canSetupToolCertificate = original?.groupId === userInfoHeader.groupId && !original?.toolCertificate;
                    return (
                        <div
                            className={classNames('d-flex align-items-center justify-content-center flex-gap-10', canSetupToolCertificate && 'cursor-pointer')}
                            onClick={canSetupToolCertificate ? () => handleShowToolCertificateModal(original?.id, original?.syncEnable) : undefined}
                        >

                            {
                                canSetupToolCertificate ?
                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.4375 7.5625C3.4375 7.38016 3.50993 7.2053 3.63886 7.07636C3.7678 6.94743 
                                            3.94266 6.875 4.125 6.875H11C11.1823 6.875 11.3572 6.94743 11.4861 7.07636C11.6151 
                                            7.2053 11.6875 7.38016 11.6875 7.5625C11.6875 7.74484 11.6151 7.9197 11.4861 8.04864C11.3572 8.17757 
                                            11.1823 8.25 11 8.25H4.125C3.94266 8.25 3.7678 8.17757 3.63886 8.04864C3.50993 7.9197 3.4375 7.74484 
                                            3.4375 7.5625ZM4.125 10.3125C3.94266 10.3125 3.7678 10.3849 3.63886 10.5139C3.50993 10.6428 3.4375 
                                            10.8177 3.4375 11C3.4375 11.1823 3.50993 11.3572 3.63886 11.4861C3.7678 11.6151 3.94266 11.6875 
                                            4.125 11.6875H7.5625C7.74484 11.6875 7.91971 11.6151 8.04864 11.4861C8.17757 11.3572 8.25 11.1823 
                                            8.25 11C8.25 10.8177 8.17757 10.6428 8.04864 10.5139C7.91971 10.3849 7.74484 10.3125 7.5625 
                                            10.3125H4.125ZM3.4375 14.4375C3.4375 14.2552 3.50993 14.0803 3.63886 13.9514C3.7678 13.8224 
                                            3.94266 13.75 4.125 13.75H8.83988L7.47656 15.125H4.125C3.94266 15.125 3.7678 15.0526 3.63886 
                                            14.9236C3.50993 14.7947 3.4375 14.6198 3.4375 14.4375ZM6.14419 17.875H2.40625C2.13275 17.875 1.87044 
                                            17.7663 1.67705 17.573C1.48365 17.3796 1.375 17.1173 1.375 16.8438V3.78125C1.375 3.50775 1.48365 
                                            3.24544 1.67705 3.05205C1.87044 2.85865 2.13275 2.75 2.40625 2.75H3.55438C3.69661 3.1523 3.96011 
                                            3.50057 4.30858 3.74684C4.65704 3.9931 5.0733 4.12522 5.5 4.125H9.625C10.0517 4.12522 10.468 
                                            3.9931 10.8164 3.74684C11.1649 3.50057 11.4284 3.1523 11.5706 2.75H12.7188C12.9923 2.75 13.2546 
                                            2.85865 13.448 3.05205C13.6413 3.24544 13.75 3.50775 13.75 3.78125V8.96775C14.172 8.73513 14.6434 
                                            8.60667 15.125 8.59306V3.78125C15.125 3.14307 14.8715 2.53103 14.4202 2.07977C13.969 1.62852 
                                            13.3569 1.375 12.7188 1.375H11.5706C11.4284 0.972705 11.1649 0.624427 10.8164 0.378164C10.468 
                                            0.131901 10.0517 -0.00022341 9.625 2.83575e-07H5.5C5.0733 -0.00022341 4.65704 0.131901 
                                            4.30858 0.378164C3.96011 0.624427 3.69661 0.972705 3.55438 1.375H2.40625C1.76807 1.375 
                                            1.15603 1.62852 0.704774 2.07977C0.253515 2.53103 0 3.14307 0 3.78125V16.8438C0 
                                            17.4819 0.253515 18.094 0.704774 18.5452C1.15603 18.9965 1.76807 19.25 2.40625 
                                            19.25H5.84375C5.84375 19.1084 5.86254 18.964 5.90013 18.8169L6.14419 
                                            17.875ZM5.5 1.375H9.625C9.80734 1.375 9.98221 1.44743 10.1111 1.57636C10.2401 
                                            1.7053 10.3125 1.88016 10.3125 2.0625C10.3125 2.24484 10.2401 2.4197 10.1111 
                                            2.54864C9.98221 2.67757 9.80734 2.75 9.625 2.75H5.5C5.31766 2.75 5.1428 
                                            2.67757 5.01386 2.54864C4.88493 2.4197 4.8125 2.24484 4.8125 2.0625C4.8125 
                                            1.88016 4.88493 1.7053 5.01386 1.57636C5.1428 1.44743 5.31766 1.375 5.5 1.375ZM16.599 
                                            13.0103L10.6796 18.8836C10.4377 19.123 10.1367 19.2941 9.80719 19.3792L7.73094 
                                            19.9141C7.6151 19.9438 7.49352 19.9427 7.37822 19.911C7.26291 19.8794 7.15786 19.8181 
                                            7.07345 19.7335C6.98903 19.6488 6.92817 19.5435 6.89686 19.4281C6.86555 19.3127 6.86489 
                                            19.1911 6.89494 19.0754L7.43806 16.9785C7.51916 16.6653 7.6819 16.3792 7.90969 16.1494L13.7995 
                                            10.2094C13.9868 10.0206 14.2102 9.87149 14.4564 9.77093C14.7025 9.67038 14.9664 9.62044 15.2323 
                                            9.62409C15.4982 9.62775 15.7606 9.68493 16.004 9.79222C16.2473 9.89951 16.4665 10.0547 16.6485 
                                            10.2486C17.0016 10.6246 17.1941 11.1237 17.1848 11.6395C17.1756 12.1553 16.9654 12.6471 
                                            16.599 13.0103Z" fill="#4EA953" />
                                    </svg>

                                    :
                                    <div style={{ width: '20px', height: '15px' }}></div>
                            }
                        </div>
                    );
                },
                width: '130'
            },
            {
                Header: '研修認定新規・更新',
                accessor: 'toolCertificateType',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.toolCertificate?.type && (original?.toolCertificate?.type == SETTING_TOOL_CERTIFICATE_TYPE.NEW ? '新規' : '更新')}
                        </div>
                    );
                },
                width: '180'
            },
            {
                Header: '研修単位取得期間',
                accessor: 'toolCertificateStartDate',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.toolCertificate?.startDate ?
                                // eslint-disable-next-line max-len
                                `${moment(original.toolCertificate.startDate).format(DATE_YMD)} ~ ${calculateDateAfterYear(original.toolCertificate.startDate,
                                    original?.toolCertificate?.type == SETTING_TOOL_CERTIFICATE_TYPE.NEW ? 4 : 3)}`
                                : ''
                            }
                        </div>
                    );
                },
                width: '150'
            },
            {
                Header: '残日数',
                accessor: 'start_current_period',
                disableSortBy: false,
                Cell: ({ row: { original } }) => {
                    let remainingData;
                    if (original?.toolCertificate?.startCurrentPeriod && original?.toolCertificate?.value) {
                        remainingData = calculateRemainingDays(
                            original.toolCertificate.startCurrentPeriod,
                            original.toolCertificate.value)
                    }

                    return (
                        <div>
                            {original?.toolCertificate?.startCurrentPeriod && original?.toolCertificate?.value ?
                                (
                                    <div className='text-center'>
                                        <div className={classNames(remainingData?.remainingDays > 0 ? '' : 'text-danger fw-bold')}>
                                            {remainingData?.remainingDays > 0 ? remainingData.remainingDays : 0}
                                        </div>
                                        {
                                            remainingData?.remainingDays > 0 && (
                                                <div style={{ color: '#AAAAAA', fontSize: '14px' }}>{`(${remainingData?.currentPeriodIndex}年目)`}</div>
                                            )
                                        }
                                    </div>
                                ) : <></>
                            }
                        </div>
                    );
                },
                width: '150'
            },
            {
                Header: '認定判定',
                accessor: 'last_status',
                disableSortBy: false,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {
                                SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[original?.toolCertificate?.lastStatus] &&
                                // <img src={SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[original.toolCertificate.lastStatus].IMG}
                                //     width={20}
                                // />
                                <span className='fw-bolder'
                                    style={{ 'color': SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[original.toolCertificate.lastStatus].TEXT_COLOR }}>
                                    {SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[original.toolCertificate.lastStatus].LABEL}
                                </span>
                            }
                        </div>
                    );
                },
                width: '120'
            },
            ...(Array.from({ length: 4 }).map((_, index) => ({
                Header: `${index + 1}年目`,
                accessor: `toolCertificateValue${index}`,
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {
                                original?.toolCertificate?.value?.[index] && (
                                    !original.toolCertificate.value[index].disabled ? (
                                        original.toolCertificate.value[index].totalCourseCompletion > 0 ?
                                            <Link
                                                to={`/student-detail/${original.id}?status=${COURSE_BY_STUDENT_STATUS.USER_COURSE_COMPLETE.key}`}
                                            >
                                                {original.toolCertificate.value[index].totalCourseCompletion}
                                            </Link>
                                            : original.toolCertificate.value[index].totalCourseCompletion
                                    ) : '-'
                                )
                            }
                            {
                                index === 3 &&
                                original?.toolCertificate?.type &&
                                original?.toolCertificate?.type == SETTING_TOOL_CERTIFICATE_TYPE.UPDATE &&
                                '-'
                            }
                        </div>
                    );
                },
                width: '80'
            }))),
            {
                Header: 'アクション',
                accessor: 'action',
                disableSortBy: true,
                headerClassName: 'sticky-column  width-150',
                className: 'sticky-dropdown sticky-column width-150',
                Cell: ({ row: { original } }) => {
                    return (
                        <div className='d-flex align-items-center justify-content-center flex-gap-10'>
                            { Number(original?.groupId) === Number(userInfo?.groupId) &&
                                <div style={{
                                    border: '1px solid #F36D3B',
                                    borderRadius: '5px',   
                                    // padding: '2px 5.5px',
                                    cursor: 'pointer',
                                    height: '34px',
                                    width: '34px'
                                }} 
                                className='d-flex align-items-center justify-content-center'
                                onClick={() => handleShowResignationModal(original)}>
                                    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        {/* eslint-disable-next-line max-len */}
                                        <path d="M7.6 0C6.59218 0 5.62563 0.398015 4.91299 1.10649C4.20036 1.81496 3.8 2.77585 3.8 3.77778C3.8 4.77971 4.20036 5.7406 4.91299 6.44907C5.62563 7.15754 6.59218 7.55556 7.6 7.55556C8.60782 7.55556 9.57437 7.15754 10.287 6.44907C10.9996 5.7406 11.4 4.77971 11.4 3.77778C11.4 2.77585 10.9996 1.81496 10.287 1.10649C9.57437 0.398015 8.60782 0 7.6 0ZM14.725 8.5C12.35 8.5 10.45 10.3889 10.45 12.75C10.45 15.1111 12.35 17 14.725 17C17.1 17 19 15.1111 19 12.75C19 10.3889 17.1 8.5 14.725 8.5ZM7.6 9.44444C3.401 9.44444 0 11.135 0 13.2222V15.1111H9.025C8.71144 14.363 8.55 13.5605 8.55 12.75C8.55407 11.6302 8.86616 10.5328 9.4525 9.57667C8.854 9.50111 8.246 9.44444 7.6 9.44444ZM14.725 9.91667C16.302 9.91667 17.575 11.1822 17.575 12.75C17.575 13.2789 17.4325 13.77 17.176 14.1667L13.3 10.3133C13.699 10.0583 14.193 9.91667 14.725 9.91667ZM12.274 11.3333L16.15 15.1867C15.751 15.4417 15.257 15.5833 14.725 15.5833C13.148 15.5833 11.875 14.3178 11.875 12.75C11.875 12.2211 12.0175 11.73 12.274 11.3333Z" fill="#F36D3B"/>
                                    </svg>

                                </div>
                            }
                            <button style={{
                                border: '1px solid #FFB900',
                                borderRadius: '5px',   
                                // padding: '2px 0px',
                                cursor: 'pointer',
                                backgroundColor: 'white',
                                height: '34px',
                                width: '34px'
                            }}
                            className="fa-solid fa-lg cursor-pointer d-flex align-items-center justify-content-center"
                            onClick={() => window.open(`/student-detail/${original.id}`, '_blank')}
                            title='受検履歴EE'
                            >
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_4880_5986)">
                                        <rect width="18" height="18" rx="9" fill="#FFB900"/>
                                        <path d="M9.522 13.196C8.794 13.196 8.136 13.0327 7.548 12.706C6.96 12.3793 6.48867 11.908 6.134 11.292C5.78867 10.676 5.616 9.93867 5.616 9.08C5.616 8.44533 5.714 7.876 5.91 7.372C6.11533 6.868 6.39067 6.43867 6.736 6.084C7.09067 5.72 7.48267 5.44467 7.912 5.258C8.35067 5.062 8.80333 4.964 9.27 4.964C9.98867 4.964 10.5907 5.12733 11.076 5.454C11.5613 5.77133 11.9253 6.21467 12.168 6.784C12.42 7.344 12.546 7.988 12.546 8.716C12.546 8.90267 12.5367 9.08467 12.518 9.262C12.4993 9.43 12.476 9.56533 12.448 9.668H7.618C7.674 10.088 7.8 10.4427 7.996 10.732C8.192 11.0213 8.444 11.2407 8.752 11.39C9.06 11.53 9.41 11.6 9.802 11.6C10.1193 11.6 10.418 11.558 10.698 11.474C10.978 11.3807 11.2627 11.2453 11.552 11.068L12.252 12.328C11.8693 12.5893 11.44 12.7993 10.964 12.958C10.488 13.1167 10.0073 13.196 9.522 13.196ZM7.576 8.282H10.782C10.782 7.75933 10.6607 7.344 10.418 7.036C10.1847 6.71867 9.81133 6.56 9.298 6.56C9.02733 6.56 8.77067 6.62533 8.528 6.756C8.28533 6.87733 8.08 7.06867 7.912 7.33C7.744 7.582 7.632 7.89933 7.576 8.282Z" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4880_5986">
                                            <rect width="18" height="18" rx="9" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                            {(original?.syncEnable && original?.company?.two_way_sync_enable) && (
                                <button style={{
                                    border: '1px solid #4EA953',
                                    borderRadius: '5px',
                                    // padding: '2px 0px',
                                    cursor: 'pointer',
                                    backgroundColor: 'white',
                                    height: '34px',
                                    width: '34px'
                                }}
                                className="fa-solid fa-lg cursor-pointer d-flex align-items-center justify-content-center"
                                title='受検履歴EI'
                                onClick={() => window.open(`/student-detail-ei/${original.id}`, '_blank')}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="18" height="18" rx="9" fill="#4EA953"/>
                                        <path d="M8.274 14V3.626H10.346V14H8.274Z" fill="white"/>
                                    </svg>
                                </button>
                            )}
                            


                            {/* <img
                                role={'button'}
                                className=''
                                src='/images/eye.svg'
                                alt=''
                                onClick={() => window.open(`/student-detail/${original.id}`, '_blank')} /> */}
                        </div>
                    );
                }
            }
        ]

        if (userInfoHeader?.groups?.length > 1) {
            defaultColumns.splice(3, 0, {
                Header: '法人名',
                accessor: 'groupName',
                disableSortBy: true,
                Cell: ({ row: { original } }) => {
                    return (
                        <div>
                            {original?.groupName}
                        </div>
                    );
                },
                width: '220'
            })
        }

        return defaultColumns;
    }, [
        userInfoHeader?.groups?.length,
        userInfoHeader?.enableDepartmentHierarchy,
        studentsOfCompany,
        isSelectedAllCustom,
        toggleClearSelectedBtn,
        selectedRowIds
    ])

    return (
        <div id='main' className='wrapper main-student-list student-group-screen'>
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className='container container-student-group-list'>
                    <ul>
                        <li>
                            <Link to={SYSTEM_PATH.HOME}><img src='/images/icon-home.png' alt='' /></Link>
                        </li>
                        <li className='dash'>\</li>
                        <li>受講者リスト</li>
                    </ul>
                </div>
            </div>
            <section className='top-student-list'>
                <div className='container container-student-group-list'>
                    <h1 className='title-primary'>受講者リスト</h1>
                    <div className='content-top-student'>
                        <form onSubmit={handleSubmit(onSearchData)}>
                            <div className='row'>
                                {/* student name */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label htmlFor='studentName'>受講者名</label>
                                        <input type='text' id='studentName' {...register('studentName')} />
                                    </div>
                                </div>

                                {/* ticket */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label htmlFor='ticketId'>受講コース</label>
                                        <select className='select-status-student' {...register('ticketId')} id='ticketId'>
                                            <option value={''}>全て</option>
                                            {
                                                ticketByGroup?.length > 0 &&
                                                ticketByGroup.map(e => <option key={e.id} value={e.id}>{e.name}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>

                                {/* email */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label htmlFor='email'>メールアドレス</label>
                                        <input type='text' id='email' {...register('email')} />
                                    </div>
                                </div>

                                {/* Application date */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label>申込み期間</label>
                                        <CalendarCustom
                                            ranges={getValues('coursePeriod_1', undefined)}
                                            displayMode={'dateRange'}
                                            //onChange={(ranges) => onChangeDateRange(ranges, 'startCoursePeriod_1')}
                                            onChange={date => {
                                                setValue('coursePeriod_1', date.selection ? [date.selection] : undefined);
                                                trigger('coursePeriod_1');
                                            }}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                {/* course name */}
                                <div className='col-md-6 col-sm-6 col-12 gr-course-wrapper'>
                                    <div className='item'>
                                        <label htmlFor='courseName'>受講済講座名</label>
                                        <input
                                            value={courseName}
                                            onChange={handleChangeCourse}
                                            onFocus={handleChangeCourse}
                                            type='text' id='courseName'
                                            autoComplete='off'
                                        />
                                    </div>
                                    {showListCourse && <div className='item gr-course-view'>
                                        <label></label>
                                        <div className='gr-course-list'>
                                            {courses.map((item, i) => {
                                                return (
                                                    <p key={i} onClick={() => handleSelectCourse(item)}>{item.name}</p>
                                                );
                                            })}
                                        </div>
                                    </div>}
                                </div>
                                {/* attendance code — combobox with search, single selection (#17899) */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label htmlFor='attendanceCodeId'>受講コード</label>
                                        <Controller
                                            control={control}
                                            name='attendanceCodeId'
                                            render={({ field: { onChange } }) => (
                                                <AsyncSelect
                                                    inputId='attendanceCodeId'
                                                    className='react-select'
                                                    cacheOptions
                                                    defaultOptions
                                                    isClearable
                                                    placeholder=''
                                                    noOptionsMessage={() => '該当する受講コードが見つかりません。'}
                                                    loadOptions={loadAttendanceCodeOptions}
                                                    value={selectedAttendanceCodeOption}
                                                    onChange={(option) => {
                                                        setSelectedAttendanceCodeOption(option);
                                                        onChange(option?.value ?? '');
                                                    }}
                                                    styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                {/* start course period */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label>受講期間</label>
                                        <CalendarCustom
                                            ranges={getValues('startCoursePeriod', undefined)}
                                            displayMode={'dateRange'}
                                            onChange={(ranges) => onChangeDateRange(ranges, 'startCoursePeriod')}
                                        />
                                    </div>
                                </div>
                                {/* ticketplan — depends on the selected attendance code above (#17899) */}
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='item'>
                                        <label htmlFor='ticketPlanId'>研修指定受講プラン</label>
                                        <select className='select-status-student' {...register('ticketPlanId')} id='ticketPlanId'>
                                            <option value={''}>全て</option>
                                            {
                                                ticketPlanOptions.length > 0
                                                    ? ticketPlanOptions.map(e => <option key={e.id} value={e.id}>{e.name}</option>)
                                                    : <option value={'__no_ticket_plan__'} disabled>研修指定受講プランが見つかりません。</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6 col-sm-6 col-12 gr-course-wrapper'>
                                    <div className='select-search-toolcertificate-type'>
                                        <label>研修認定新規・更新</label>
                                        <div className='d-flex align-items-center flex-wrap'>
                                            {
                                                Object.values(SETTING_TOOL_CERTIFICATE_TYPE).map((toolCertificateType, index) => (
                                                    <div
                                                        key={index}
                                                        className={classNames('select-search-btn',
                                                            // eslint-disable-next-line max-len
                                                            toolCertificateTypeSearch.includes(toolCertificateType) && 'select-search-toolcertificate-active')}
                                                        onClick={() => onCheckToolCertificateTypeSearch(toolCertificateType)}
                                                    >{SETTING_TOOL_CERTIFICATE_TYPE_MAPPER[toolCertificateType].LABEL}</div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 col-sm-6 col-12'>
                                    <div className='select-search-toolcertificate-type'>
                                        <label htmlFor='status'>認定判定</label>
                                        <div className='d-flex align-items-center flex-wrap'>
                                            {
                                                Object.values(SETTING_TOOL_CERTIFICATE_STATUS_MAPPER)
                                                    .map(item => item.LABEL).sort()
                                                    .map((toolCertificateStatus, index) => {
                                                        // eslint-disable-next-line max-len
                                                        const toolCertificateStatusValue = Object.keys(SETTING_TOOL_CERTIFICATE_STATUS_MAPPER).find(key => SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[key].LABEL === toolCertificateStatus)
                                                        return (
                                                            <div
                                                                key={index}
                                                                className={classNames('select-search-btn',
                                                                    // eslint-disable-next-line max-len
                                                                    toolCertificateStatusSearch.includes(toolCertificateStatusValue) && 'select-search-toolcertificate-active'
                                                                )}
                                                                onClick={() => onCheckToolCertificateStatusSearch(toolCertificateStatusValue)
                                                                }
                                                            >{toolCertificateStatus}</div>
                                                        )
                                                    })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>





                            <div className='row item-search-group'>
                                <div className='item item-1 item-2'>
                                    <div className='item-1-1'>
                                        <input type={'checkbox'} id='受講プラン消化率'
                                            {...register('isCompleteRate')}
                                            onChange={(e) => onChangeCheckbox('isCompleteRate', e.target.checked, 'isTotalCourseApply')} />
                                        <label htmlFor='受講プラン消化率'>受講プラン消化率</label>
                                    </div>
                                    <input
                                        type={'number'}
                                        {...register('completeRate')}
                                        min={0}
                                        max={100}
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!getValues('isCompleteRate')} />
                                </div>
                                <div className='item item-1 item-2'>
                                    <div className='item-1-1'>
                                        <input type={'checkbox'} id='申請単位数'
                                            {...register('isTotalCourseApply')}
                                            onChange={(e) => onChangeCheckbox('isTotalCourseApply', e.target.checked, 'isCompleteRate')} />
                                        <label htmlFor='申請単位数'>申請単位数</label>
                                    </div>
                                    <input
                                        type={'number'}
                                        min={0}
                                        {...register('totalCourseApply')}
                                        onWheel={(e) => e.target.blur()}
                                        disabled={!getValues('isTotalCourseApply')} />
                                </div>
                                <div className='item item-1'>
                                    <select className='select-level' {...register('isBiggerCompleteRate')} defaultValue={'0'}
                                        disabled={!getValues('isTotalCourseApply') && !getValues('isCompleteRate')}>
                                        <option value={0}>以下</option>
                                        <option value={1}>以上</option>
                                    </select>
                                </div>
                            </div>
                            <div className='text-center'>
                                <input type='submit' value='検索' disabled={isSubmitting} />
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <section className='content-student-list'>
                <div className='container container-student-group-list'>
                    <div className='filter-list'>
                        <ul className='filter-list-container'>
                            {
                                selectedStudent?.length > 0 && (
                                    <li
                                        role={'button'}
                                        // className={classNames(!studentSelectedInDirectGroup && 'btn-disable')}
                                        onClick={clearSelectedStudent}>
                                        <a className='mg-l-0 pd-l-0 delete-all-send'>
                                            <i className='fa-solid fa-square-minus'></i>
                                            <span>すべてのデータを削除する</span>
                                        </a>
                                    </li>
                                )
                            }
                            {
                                canShowDepartmentTransfer && (
                                    <li role={'button'} onClick={onShowDepartmentTransfer}>
                                        <a className='filter-list-last'>
                                            <img src='/images/icon-department-transfer.svg' alt='' />
                                            部署異動
                                        </a>
                                    </li>
                                )
                            }
                            <li
                                role={'button'}
                                className={classNames(!studentSelectedInDirectGroup && 'btn-disable')}
                                onClick={studentSelectedInDirectGroup ? () => onShowSendMessage() : () => { }}>
                                <a className='filter-list-last'><img src='/images/icon12.svg' alt='' />メッセージ送信</a>
                            </li>
                            <li
                                role={'button'}
                                className={classNames(studentsOfCompany?.length <= 0 && 'btn-disable')}
                                onClick={studentsOfCompany?.length > 0 ? () => onExportTestResultCsv() : () => { }}>
                                <a className='filter-list-last'>
                                    <i
                                        className='fa-regular fa-file-lines fa-xl cursor-pointer mg-r-5'
                                        style={{ color: '#1A2C44' }}>
                                    </i>
                                    テスト結果をダウンロード
                                </a>
                            </li>
                            <li role={'button'} onClick={onExportCSV}>
                                <a className='filter-list-last'><img src='/images/icon13.svg' alt='' />受講記録の出力</a>
                            </li>
                        </ul>
                    </div>
                    <Table
                        columns={studentColumns}
                        data={studentsOfCompany || []}
                        enableServerSidePaging={true}
                        initialTableState={pagingStudentOfCompany}
                        onFetch={onFetchData}
                        enableSelectRow={true}
                        onSelectedChange={onSelectedChange}
                        selectedRowIds={selectedRowIds}
                        rowKey={'id'}
                        disableSubRowSelect={true}
                        lstDisabledRowSelect={disabledStudentIdx}
                        showDisabledRowSelect={false}
                        useCustomSelectedAll={true}
                        isSelectedAllCustom={isSelectedAllCustom}
                        isSelectedAll={false}
                        onSelectedAllChange={onSelectedAllChange}
                        className='lst-student-table mg-t-35'
                        freezeColumn
                        isMultiSort
                        enableDragScroll={true}
                        enableStickyHeader={true}
                    />
                </div>
            </section>
            <SendMessageScreen selectedStudent={selectedStudent} selectedRowIds={selectedRowIds} setSelectedStudent={setSelectedStudent} />
            <DepartmentTransferModal
                onClose={onCloseDepartmentTransfer}
                onDownloadTemplate={onDownloadDepartmentTransferTemplate}
                onReloadStudentList={() => onFetchData(keepDataSearch)}
            />
                            
            <section>
                <div className='container container-student-group-list text-error font-bold mg-t-10 text-14'>
                    <div>【認定判定について】</div>
                    <div>A：新規の場合は合計40単位以上、更新の場合は３年目で30単位以上となった時点で表示。</div>
                    <div>B：更新の場合に5単位以上となった時点で表示。</div>
                    <div>C：更新の場合に5単位未満の時点で表示。</div>
                    <div>D：研修認定期間の最終日までにAにならなかった場合に表示。</div>
                </div>
            </section>
        </div>

    )
})

export default StudentGroupScreen;